module.exports = __webpack_public_path__ + "static/media/42.4d60da66.png";